/**
 * AMC DC — GOVX Verify = same path as the official app-block CTA:
 *   onclick="return GOVXID_APP.pop(this)" → window.open(..., "GOVXID Verification", w/h)
 *
 * Why new tabs happened before:
 *   Remote govx.js rewrites anchors to href="#" target="popup" and replaces onclick with
 *   a handler that does NOT return false / preventDefault. The browser then follows
 *   target="popup" → new tab. We stop that here (capture) and only call GOVXID_APP.pop.
 *
 * Never: location.href, target=_blank, window.open(_blank), synthetic new-tab <a>.
 */
(function () {
  var AUTH_URL =
    'https://auth.govx.com/shopify/verify?shop=artmasterclass-usa-west.myshopify.com&utm_source=shopify&utm_medium=govxid&utm_campaign=govxid_button_app_block';

  function hideGovxAppsSection() {
    var node = document.querySelector('[data-govx-id]');
    if (!node) return;
    var section = node.closest('.shopify-section');
    if (!section) return;
    section.classList.add('amc-dc-govx-host');
    section.setAttribute('aria-hidden', 'true');
  }

  function authUrlFrom(el) {
    if (!el) return AUTH_URL;
    var raw = el.getAttribute('data-amc-dc-govx-url');
    if (raw && raw.indexOf('auth.govx.com') !== -1) return raw;
    var href = el.getAttribute('href');
    if (href && href.indexOf('auth.govx.com') !== -1) return href;
    return AUTH_URL;
  }

  function stampTriggers() {
    document.querySelectorAll('[data-amc-dc-govx-trigger]').forEach(function (el) {
      if (!el.getAttribute('data-amc-dc-govx-url')) {
        var href = el.getAttribute('href');
        el.setAttribute(
          'data-amc-dc-govx-url',
          href && href.indexOf('auth.govx.com') !== -1 ? href : AUTH_URL
        );
      }
      // Keep markup aligned with official CTA; pop uses URL string we stamp.
      el.setAttribute('href', '#');
      el.setAttribute('target', 'popup');
      el.setAttribute('data-action', 'govx-id-pop');
      el.setAttribute('onclick', 'return false');
    });
  }

  function onClickCapture(e) {
    var el = e.target && e.target.closest && e.target.closest('[data-amc-dc-govx-trigger]');
    if (!el) return;

    // Kill link default (target=popup → new tab) and any later GOVX handlers.
    e.preventDefault();
    e.stopImmediatePropagation();

    var url = authUrlFrom(el);
    if (window.GOVXID_APP && typeof window.GOVXID_APP.pop === 'function') {
      window.GOVXID_APP.pop(url);
    }
  }

  function boot() {
    hideGovxAppsSection();
    stampTriggers();
  }

  document.addEventListener('click', onClickCapture, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);

  // Re-stamp after govx.js mutates anchors (href → #, onclick overwrite).
  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    stampTriggers();
    hideGovxAppsSection();
    if (tries > 40) clearInterval(timer);
  }, 250);
})();
